import React from "react";
import CmsPage from "../CmsPage/CmsPage";
import "./Careers.scss";

const Careers = () => {
  return <CmsPage id={8} />;
};

export default Careers;
